// ADR-133: Reports → Ingestion Sync Runs. Mirrors radar-api
// src/utils/ingestionSyncRunTypes.js. Run statuses are the shared
// SyncRunStatusEnum (running / success / failed), same as the DMD audit.
import {
  DISCREPANCY_RUN_STATUSES,
  DISCREPANCY_RUN_STATUS_LABELS,
  DISCREPANCY_RUN_STATUS_COLORS,
  DISCREPANCY_RUN_STATUS_OPTIONS,
} from './discrepancyMappingStatuses';

export const INGESTION_SYNC_RUNS_PATH = '/reports/ingestion-sync-runs/runs';

export const SYNC_RUN_STATUSES = DISCREPANCY_RUN_STATUSES;
export const SYNC_RUN_STATUS_LABELS = DISCREPANCY_RUN_STATUS_LABELS;
export const SYNC_RUN_STATUS_COLORS = DISCREPANCY_RUN_STATUS_COLORS;
export const SYNC_RUN_STATUS_OPTIONS = DISCREPANCY_RUN_STATUS_OPTIONS;

export const SYNC_PROVIDER_OPTIONS = [
  { value: 'AMERICAS', label: 'Americas', triggerLabel: 'Americas pipeline' },
  { value: 'POWERBI', label: 'PowerBI', triggerLabel: 'PowerBI (Enova)' },
];

export const SYNC_PROVIDER_LABELS = Object.fromEntries(SYNC_PROVIDER_OPTIONS.map((o) => [o.value, o.label]));

export const SYNC_TYPE_OPTIONS = [
  { value: 'EMPLOYEES', label: 'Employees' },
  { value: 'CLIENTS', label: 'Clients / projects' },
  { value: 'ALLOCATIONS', label: 'Allocations' },
];

export const SYNC_TYPE_LABELS = Object.fromEntries(SYNC_TYPE_OPTIONS.map((o) => [o.value, o.label]));

// Previews are never recorded (ADR-133 §6.1); dry runs only via direct API calls.
export const SYNC_MODE_OPTIONS = [
  { value: 'EXECUTE', label: 'Real runs' },
  { value: 'DRY_RUN', label: 'Dry runs' },
];

export const SYNC_MODE_LABELS = { EXECUTE: 'Real run', DRY_RUN: 'Dry run' };

// SCHEDULER = on the scheduler's timetable; MANUAL = "Trigger now" (or the
// scheduler's own run endpoint); API = radar-ingestion called directly, no batch.
export const SYNC_TRIGGER_OPTIONS = [
  { value: 'SCHEDULER', label: 'Scheduled' },
  { value: 'MANUAL', label: 'Manual' },
  { value: 'API', label: 'Direct API call' },
];

export const SYNC_TRIGGER_LABELS = Object.fromEntries(SYNC_TRIGGER_OPTIONS.map((o) => [o.value, o.label]));

// A standalone run an internal job started on a user's behalf (radar-api INGESTION_RUN_ORIGINS).
export const SYNC_RUN_ORIGIN_LABELS = {
  BENCH_CANDIDATE_IMPORT: 'Bench candidate import',
};

// Off-schedule runs stand out in the list (amber), scheduled ones stay muted.
export const SYNC_TRIGGER_COLORS = { SCHEDULER: null, MANUAL: '#B45309', API: '#B45309' };

export const RESULT_STATUSES = { PENDING: 'PENDING', COMPLETE: 'COMPLETE', INCOMPLETE: 'INCOMPLETE' };

export const BATCH_STEP_LABELS = {
  EMPLOYEES: 'Employees',
  CLIENTS: 'Clients / projects',
  ALLOCATIONS: 'Allocations',
};

export const BATCH_STEP_STATUS_LABELS = {
  NOT_STARTED: 'Not started',
  RUNNING: 'Running',
  SUCCESS: 'Success',
  FAILED: 'Failed',
  SKIPPED: 'Skipped',
};
